import { s as n, v as t } from "./caml_option-16487d6d.mjs";

import { d as r, g as e, h as u, i, j as f, k as a, l as o, n as c, u as s, r as l, a as h, o as p, m as v, p as g, c as _, q as d, b as y, t as m, v as A, w as x, e as B, s as W, x as E, y as k, z as I, A as j, B as w, f as q, C as F, D as T, E as U } from "./belt_Array-b9ebcaa6.mjs";

import { e as b, l as M } from "./caml_obj-c29533cc.mjs";

function merge(n, t, e, u, i, f, a, o, c) {
  var s = t + e | 0;
  var l = i + f | 0;
  var h = t;
  var p = n[t];
  var v = i;
  var g = u[i];
  var _ = o;
  while (1) {
    var d = _;
    var y = g;
    var m = v;
    var A = p;
    var x = h;
    if (c(A, y) <= 0) {
      a[d] = A;
      var B = x + 1 | 0;
      if (B >= s) {
        return r(u, m, a, d + 1 | 0, l - m | 0);
      }
      _ = d + 1 | 0;
      p = n[B];
      h = B;
      continue;
    }
    a[d] = y;
    var W = m + 1 | 0;
    if (W >= l) {
      return r(n, x, a, d + 1 | 0, s - x | 0);
    }
    _ = d + 1 | 0;
    g = u[W];
    v = W;
  }
}

function insertionSort(n, t, r, e, u, i) {
  for (var f = 0; f < u; ++f) {
    var a = n[t + f | 0];
    var o = (e + f | 0) - 1 | 0;
    while (o >= e && i(r[o], a) > 0) {
      r[o + 1 | 0] = r[o];
      o = o - 1 | 0;
    }
    r[o + 1 | 0] = a;
  }
}

function sortTo(n, t, r, e, u, i) {
  if (u <= 5) {
    return insertionSort(n, t, r, e, u, i);
  }
  var f = u / 2 | 0;
  var a = u - f | 0;
  sortTo(n, t + f | 0, r, e + f | 0, a, i);
  sortTo(n, t, n, t + a | 0, f, i);
  merge(n, t + a | 0, f, r, e + f | 0, a, r, e, i);
}

function stableSortByU(n, t) {
  var r = n.slice(0);
  !function stableSortInPlaceByU(n, t) {
    var r = n.length;
    if (r <= 5) {
      return insertionSort(n, 0, n, 0, r, t);
    }
    var e = r / 2 | 0;
    var u = r - e | 0;
    var i = new Array(u);
    sortTo(n, e, i, 0, u, t);
    sortTo(n, 0, n, u, e, t);
    merge(n, u, e, i, 0, u, n, 0, t);
  }(r, t);
  return r;
}

function get$1(t, r) {
  if (r in t) {
    return n(t[r]);
  }
}

var unsafeDeleteKey = function(n, t) {
  delete n[t];
};

function values(n) {
  var t = Object.keys(n);
  var r = t.length;
  var e = new Array(r);
  for (var u = 0; u < r; ++u) {
    e[u] = n[t[u]];
  }
  return e;
}

function fromArray(n) {
  var t = {};
  var r = n.length;
  for (var e = 0; e < r; ++e) {
    var u = n[e];
    t[u[0]] = u[1];
  }
  return t;
}

function placeholder(n) {}

function makeEmpty(n) {
  return [];
}

var z = v;

function makeWithIndex() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return z(t, n[0]);
    };
  }
  return z(arguments[0], arguments[1]);
}

var S = g;

function make() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return S(t, n[0]);
    };
  }
  return S(arguments[0], arguments[1]);
}

var O = g;

function repeat() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return O(t, n[0]);
    };
  }
  return O(arguments[0], arguments[1]);
}

function length(n) {
  return n.length;
}

function isEmpty(n) {
  return 0 === n.length;
}

function isNotEmpty(n) {
  return 0 !== n.length;
}

var $ = e;

function _append(n, t) {
  return _(n, [ t ]);
}

function append() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _append(t, n[0]);
    };
  }
  return _append(arguments[0], arguments[1]);
}

function _prepend(n, t) {
  return _([ t ], n);
}

function prepend() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _prepend(t, n[0]);
    };
  }
  return _prepend(arguments[0], arguments[1]);
}

function _prependToAll(n, t) {
  return l(n, [], (function(n, r) {
    return _(n, [ t, r ]);
  }));
}

function prependToAll() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _prependToAll(t, n[0]);
    };
  }
  return _prependToAll(arguments[0], arguments[1]);
}

function _intersperse(n, t) {
  return h(n, [], (function(r, e, u) {
    if ((n.length - 1 | 0) === u) {
      r.push(e);
    } else {
      r.push(e, t);
    }
    return r;
  }));
}

function intersperse() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _intersperse(t, n[0]);
    };
  }
  return _intersperse(arguments[0], arguments[1]);
}

var C = u;

function get() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return C(t, n[0]);
    };
  }
  return C(arguments[0], arguments[1]);
}

var D = u;

function at() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return D(t, n[0]);
    };
  }
  return D(arguments[0], arguments[1]);
}

function _getUnsafe(n, t) {
  return n[t];
}

function getUnsafe() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _getUnsafe(t, n[0]);
    };
  }
  return _getUnsafe(arguments[0], arguments[1]);
}

function _getUndefined(n, t) {
  return n[t];
}

function getUndefined() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _getUndefined(t, n[0]);
    };
  }
  return _getUndefined(arguments[0], arguments[1]);
}

var N = d;

function getBy() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return N(t, n[0]);
    };
  }
  return N(arguments[0], arguments[1]);
}

var R = d;

function find() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return R(t, n[0]);
    };
  }
  return R(arguments[0], arguments[1]);
}

function head(n) {
  return u(n, 0);
}

function last(n) {
  var t = n.length;
  if (0 === t) {
    return;
  } else {
    return u(n, t - 1 | 0);
  }
}

function tail(n) {
  var t = n.length;
  if (1 === t) {
    return [];
  }
  if (0 === t) {
    return;
  }
  var r = i(n, 1);
  if (0 !== r.length) {
    return r;
  }
}

function tailOrEmpty(n) {
  var t = tail(n);
  if (void 0 !== t) {
    return t;
  } else {
    return [];
  }
}

function init(n) {
  var t = n.length;
  if (0 === t) {
    return;
  } else {
    return f(n, 0, t - 1 | 0);
  }
}

function initOrEmpty(n) {
  var t = init(n);
  if (void 0 !== t) {
    return t;
  } else {
    return [];
  }
}

function _take(n, t) {
  var r = n.length;
  return f(n, 0, t < 0 ? 0 : r < t ? r : t);
}

function take() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _take(t, n[0]);
    };
  }
  return _take(arguments[0], arguments[1]);
}

function _takeExactly(n, t) {
  if (t < 0 || t > n.length) {
    return;
  } else {
    return f(n, 0, t);
  }
}

function takeExactly() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _takeExactly(t, n[0]);
    };
  }
  return _takeExactly(arguments[0], arguments[1]);
}

function _takeWhile(n, t) {
  var r = 0;
  var e = !1;
  var u = [];
  while (r < n.length && !e) {
    var i = n[r];
    if (t(i)) {
      u.push(i);
      r = r + 1 | 0;
    } else {
      e = !0;
    }
  }
  return u;
}

function takeWhile() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _takeWhile(t, n[0]);
    };
  }
  return _takeWhile(arguments[0], arguments[1]);
}

function _drop(n, t) {
  var r = n.length;
  return i(n, t < 0 ? 0 : r < t ? r : t);
}

function drop() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _drop(t, n[0]);
    };
  }
  return _drop(arguments[0], arguments[1]);
}

function _dropExactly(n, t) {
  if (t < 0 || t > n.length) {
    return;
  } else {
    return i(n, t);
  }
}

function dropExactly() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _dropExactly(t, n[0]);
    };
  }
  return _dropExactly(arguments[0], arguments[1]);
}

function _dropWhile(n, t) {
  return l(n, [], (function(n, r) {
    if (!t(r)) {
      n.push(r);
    }
    return n;
  }));
}

function dropWhile() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _dropWhile(t, n[0]);
    };
  }
  return _dropWhile(arguments[0], arguments[1]);
}

function uncons(n) {
  if (0 !== n.length) {
    return [ a(n, 0), i(n, 1) ];
  }
}

function _map(n, t) {
  return y(n, t);
}

function map() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _map(t, n[0]);
    };
  }
  return _map(arguments[0], arguments[1]);
}

var G = m;

function mapWithIndex() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return G(t, n[0]);
    };
  }
  return G(arguments[0], arguments[1]);
}

function _filter(n, t) {
  var r = 0;
  var e = [];
  while (r < n.length) {
    var u = n[r];
    if (t(u)) {
      e.push(u);
    }
    r = r + 1 | 0;
  }
  return e;
}

function filter() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _filter(t, n[0]);
    };
  }
  return _filter(arguments[0], arguments[1]);
}

var P = filter;

function _filterWithIndex(n, t) {
  var r = 0;
  var e = [];
  while (r < n.length) {
    var u = n[r];
    if (t(r, u)) {
      e.push(u);
    }
    r = r + 1 | 0;
  }
  return e;
}

function filterWithIndex() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _filterWithIndex(t, n[0]);
    };
  }
  return _filterWithIndex(arguments[0], arguments[1]);
}

var H = filterWithIndex;

function _reject(n, t) {
  return filter(n, (function(n) {
    return !t(n);
  }));
}

function reject() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _reject(t, n[0]);
    };
  }
  return _reject(arguments[0], arguments[1]);
}

function _rejectWithIndex(n, t) {
  return filterWithIndex(n, (function(n, r) {
    return !t(n, r);
  }));
}

function rejectWithIndex() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _rejectWithIndex(t, n[0]);
    };
  }
  return _rejectWithIndex(arguments[0], arguments[1]);
}

var J = l;

function reduce() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return J(t, n[0], n[1]);
    };
  }
  return J(arguments[0], arguments[1], arguments[2]);
}

var K = A;

function reduceReverse() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return K(t, n[0], n[1]);
    };
  }
  return K(arguments[0], arguments[1], arguments[2]);
}

var L = h;

function reduceWithIndex() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return L(t, n[0], n[1]);
    };
  }
  return L(arguments[0], arguments[1], arguments[2]);
}

function _splitAt(n, t) {
  if (t < 0 || t > n.length) {
    return;
  } else {
    return [ f(n, 0, t), i(n, t) ];
  }
}

function splitAt() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _splitAt(t, n[0]);
    };
  }
  return _splitAt(arguments[0], arguments[1]);
}

function _splitEvery(n, t) {
  if (t < 1 || n.length <= t) {
    return [ n ];
  }
  var r = 0;
  var e = [];
  while (r < n.length) {
    var u = r + t | 0;
    e.push(f(n, r, t));
    r = u;
  }
  return e;
}

function splitEvery() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _splitEvery(t, n[0]);
    };
  }
  return _splitEvery(arguments[0], arguments[1]);
}

var Q = o;

var V = x;

function partition() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return V(t, n[0]);
    };
  }
  return V(arguments[0], arguments[1]);
}

var X = _;

function concat() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return X(t, n[0]);
    };
  }
  return X(arguments[0], arguments[1]);
}

var Y = c;

var Z = B;

function every() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return Z(t, n[0]);
    };
  }
  return Z(arguments[0], arguments[1]);
}

var nn = W;

function some() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return nn(t, n[0]);
    };
  }
  return nn(arguments[0], arguments[1]);
}

var tn = f;

function slice() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return tn(t, n[0], n[1]);
    };
  }
  return tn(arguments[0], arguments[1], arguments[2]);
}

var rn = i;

function sliceToEnd() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return rn(t, n[0]);
    };
  }
  return rn(arguments[0], arguments[1]);
}

var en = E;

function eq() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return en(t, n[0], n[1]);
    };
  }
  return en(arguments[0], arguments[1], arguments[2]);
}

var un = k;

function range() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return un(t, n[0]);
    };
  }
  return un(arguments[0], arguments[1]);
}

var an = I;

function rangeBy() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return an(t, n[0], n[1]);
    };
  }
  return an(arguments[0], arguments[1], arguments[2]);
}

function copy(n) {
  return n.slice(0);
}

var on = j;

function zip() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return on(t, n[0]);
    };
  }
  return on(arguments[0], arguments[1]);
}

var cn = w;

function zipWith() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return cn(t, n[0], n[1]);
    };
  }
  return cn(arguments[0], arguments[1], arguments[2]);
}

var sn = s;

function _replaceAt(n, t, r) {
  return m(n, (function(n, e) {
    if (n === t) {
      return r;
    } else {
      return e;
    }
  }));
}

function replaceAt() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _replaceAt(t, n[0], n[1]);
    };
  }
  return _replaceAt(arguments[0], arguments[1], arguments[2]);
}

function _insertAt(n, t, r) {
  var e = splitAt(n, t);
  if (void 0 !== e) {
    return _(e[0], _([ r ], e[1]));
  } else {
    return n;
  }
}

function insertAt() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _insertAt(t, n[0], n[1]);
    };
  }
  return _insertAt(arguments[0], arguments[1], arguments[2]);
}

function _updateAt(n, t, r) {
  return m(n, (function(n, e) {
    if (n === t) {
      return r(e);
    } else {
      return e;
    }
  }));
}

function updateAt() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _updateAt(t, n[0], n[1]);
    };
  }
  return _updateAt(arguments[0], arguments[1], arguments[2]);
}

function _swapAt(n, r, e) {
  var i = u(n, r);
  var f = u(n, e);
  if (void 0 === i) {
    return n;
  }
  if (void 0 === f) {
    return n;
  }
  var a = t(f);
  var o = t(i);
  return m(n, (function(n, t) {
    if (r === n) {
      return a;
    } else if (e === n) {
      return o;
    } else {
      return t;
    }
  }));
}

function swapAt() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _swapAt(t, n[0], n[1]);
    };
  }
  return _swapAt(arguments[0], arguments[1], arguments[2]);
}

function _removeAt(n, t) {
  return filterWithIndex(n, (function(n, r) {
    return n !== t;
  }));
}

function removeAt() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _removeAt(t, n[0]);
    };
  }
  return _removeAt(arguments[0], arguments[1]);
}

function _uniqBy(n, t) {
  var r = 0;
  var e = [];
  while (r < n.length) {
    var u = n[r];
    var i = W(e, function(n) {
      return function(r) {
        return b(t(r), t(n));
      };
    }(u));
    if (!i) {
      e.push(u);
    }
    r = r + 1 | 0;
  }
  return e;
}

function uniqBy() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _uniqBy(t, n[0]);
    };
  }
  return _uniqBy(arguments[0], arguments[1]);
}

function uniq(n) {
  return uniqBy(n, (function(n) {
    return n;
  }));
}

var ln = q;

function forEach() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return ln(t, n[0]);
    };
  }
  return ln(arguments[0], arguments[1]);
}

var hn = F;

function forEachWithIndex() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return hn(t, n[0]);
    };
  }
  return hn(arguments[0], arguments[1]);
}

var pn = T;

function getIndexBy() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return pn(t, n[0]);
    };
  }
  return pn(arguments[0], arguments[1]);
}

function _includes(n, t) {
  return W(n, (function(n) {
    return b(n, t);
  }));
}

function includes() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _includes(t, n[0]);
    };
  }
  return _includes(arguments[0], arguments[1]);
}

function _join(n, t) {
  return n.join(t);
}

function join() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _join(t, n[0]);
    };
  }
  return _join(arguments[0], arguments[1]);
}

var vn = stableSortByU;

function sort() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return vn(t, n[0]);
    };
  }
  return vn(arguments[0], arguments[1]);
}

function _sortBy(n, t) {
  return stableSortByU(n, (function(n, r) {
    var e = t(n);
    var u = t(r);
    if (e === u) {
      return 0;
    } else if (M(e, u)) {
      return -1;
    } else {
      return 1;
    }
  }));
}

function sortBy() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _sortBy(t, n[0]);
    };
  }
  return _sortBy(arguments[0], arguments[1]);
}

function _groupBy(n, t) {
  return l(n, {}, (function(n, r) {
    var e = t(r);
    var u = get$1(n, e);
    if (void 0 !== u) {
      u.push(r);
    } else {
      n[e] = [ r ];
    }
    return n;
  }));
}

function groupBy() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _groupBy(t, n[0]);
    };
  }
  return _groupBy(arguments[0], arguments[1]);
}

function flat(n) {
  return l(n, [], (function(n, t) {
    if (Array.isArray(t)) {
      q(t, (function(t) {
        n.push(t);
      }));
    } else {
      n.push(t);
    }
    return n;
  }));
}

function _flatten(n, t) {
  var r = 0;
  while (r < n.length) {
    var e = n[r];
    if (Array.isArray(e)) {
      flatten(e, t);
    } else {
      t.push(e);
    }
    r = r + 1 | 0;
  }
  return t;
}

function flatten() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _flatten(t, n[0]);
    };
  }
  return _flatten(arguments[0], arguments[1]);
}

function deepFlat(n) {
  return flatten(n, []);
}

function toTuple(n) {
  return n;
}

function _tap(n, t) {
  q(n, t);
  return n;
}

function tap() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _tap(t, n[0]);
    };
  }
  return _tap(arguments[0], arguments[1]);
}

function flip(n) {
  return [ n[1], n[0] ];
}

var gn = U;

function filterMap() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return gn(t, n[0]);
    };
  }
  return gn(arguments[0], arguments[1]);
}

var _n = U;

function keepMap() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _n(t, n[0]);
    };
  }
  return _n(arguments[0], arguments[1]);
}

function _removeFirstBy(n, t, r) {
  return l(n, [ !1, [] ], (function(n, e) {
    var u = n[1];
    if (n[0]) {
      u.push(e);
      return [ !0, u ];
    } else if (r(e, t)) {
      return [ !0, u ];
    } else {
      u.push(e);
      return [ !1, u ];
    }
  }))[1];
}

function removeFirstBy() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _removeFirstBy(t, n[0], n[1]);
    };
  }
  return _removeFirstBy(arguments[0], arguments[1], arguments[2]);
}

function _removeFirst(n, t) {
  return removeFirstBy(n, t, b);
}

function removeFirst() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _removeFirst(t, n[0]);
    };
  }
  return _removeFirst(arguments[0], arguments[1]);
}

function zipWithIndex(n) {
  return h(n, [], (function(n, t, r) {
    n.push([ t, r ]);
    return n;
  }));
}

function _all(n, t) {
  return B(n, t);
}

function all() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _all(t, n[0]);
    };
  }
  return _all(arguments[0], arguments[1]);
}

function _any(n, t) {
  return W(n, t);
}

function any() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _any(t, n[0]);
    };
  }
  return _any(arguments[0], arguments[1]);
}

function _difference(n, t) {
  return reject(uniqBy(n, (function(n) {
    return n;
  })), (function(n) {
    return includes(t, n);
  }));
}

function difference() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _difference(t, n[0]);
    };
  }
  return _difference(arguments[0], arguments[1]);
}

function _union(n, t) {
  return uniqBy(_(n, t), (function(n) {
    return n;
  }));
}

function union() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _union(t, n[0]);
    };
  }
  return _union(arguments[0], arguments[1]);
}

function _intersection(n, t) {
  var r = n.length > t.length ? [ n, t ] : [ t, n ];
  var e = r[1];
  return uniqBy(filter(r[0], (function(n) {
    return includes(e, n);
  })), (function(n) {
    return n;
  }));
}

function intersection() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _intersection(t, n[0]);
    };
  }
  return _intersection(arguments[0], arguments[1]);
}

function sample(n) {
  return n[p(0, n.length - 1 | 0)];
}

function _flatMap(n, t) {
  return flat(y(n, t));
}

function flatMap() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _flatMap(t, n[0]);
    };
  }
  return _flatMap(arguments[0], arguments[1]);
}

export { eq as $, takeExactly as A, takeWhile as B, drop as C, dropExactly as D, dropWhile as E, uncons as F, map as G, mapWithIndex as H, filter as I, P as J, filterWithIndex as K, H as L, reject as M, rejectWithIndex as N, reduce as O, reduceReverse as P, reduceWithIndex as Q, splitAt as R, splitEvery as S, Q as T, partition as U, concat as V, Y as W, every as X, some as Y, slice as Z, sliceToEnd as _, makeWithIndex as a, range as a0, rangeBy as a1, copy as a2, zip as a3, zipWith as a4, sn as a5, replaceAt as a6, insertAt as a7, updateAt as a8, swapAt as a9, intersection as aA, sample as aB, flatMap as aC, values as aD, fromArray as aE, get$1 as aF, unsafeDeleteKey as aG, removeAt as aa, uniqBy as ab, uniq as ac, forEach as ad, forEachWithIndex as ae, getIndexBy as af, includes as ag, join as ah, sort as ai, sortBy as aj, groupBy as ak, flat as al, flatten as am, deepFlat as an, toTuple as ao, tap as ap, flip as aq, filterMap as ar, keepMap as as, removeFirstBy as at, removeFirst as au, zipWithIndex as av, all as aw, any as ax, difference as ay, union as az, make as b, isNotEmpty as c, $ as d, append as e, prepend as f, prependToAll as g, intersperse as h, isEmpty as i, get as j, at as k, length as l, makeEmpty as m, getUnsafe as n, getUndefined as o, placeholder as p, getBy as q, repeat as r, find as s, head as t, last as u, tail as v, tailOrEmpty as w, init as x, initOrEmpty as y, take as z };
